import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { MapStation } from '../../core/models';
import { HttpService, StateService } from '../../core/services';
import { LoadingComponent, SearchInputComponent } from '../../shared/components';
import { StopsState } from './stops-state';
import { LayerService } from '../map/services';
import { TranslationPipe } from '../../shared/pipes';

@Component({
  selector: 'app-stops',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, SearchInputComponent, TranslationPipe, LoadingComponent],
  templateUrl: './stops.component.html'
})
export class StopsComponent {
  private readonly searchSubject = new Subject<string>();
  public term: string = "";
  state: StopsState;  
  stop: MapStation | undefined = undefined;
  lastSearchResult: MapStation[] = [];
  loading = false;

  constructor(
    private readonly stateService: StateService,
    private readonly httpService: HttpService,
    private readonly layerService: LayerService)
  {
      this.state = this.stateService.read<StopsState>('StopsState') ?? new StopsState();
  }

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((searchValue) => {
      this.searchTextChange(searchValue);
    });
  }

  startHover(id: string) {
    this.layerService.stopsLayerService.highlightStop(id);
  }

  endHover(id: string) {
    this.layerService.stopsLayerService.highlightStop(id, true);
  }

  getTypeDescription(station: MapStation): string {
    if (station.sourceType == 'K')
      return 'Vlaková stanice';
    else if (station.sourceType == 'S')
      return 'Autobusová zastávka';
    else
      return '';
  }

  onSearch(term: string) {
    this.term = term;
    if (term)
      this.searchSubject.next(term);
    else
      this.state.searchedStops = [];
  }

  private searchTextChange(input: string) {
    this.loading = true;
    this.state.searchText = input;
    this.httpService.findStations(this.state.searchText).subscribe({
      next: result => {
        if (result.length > 0)
          this.lastSearchResult = result;

        this.state.searchedStops = result;
        this.stateService.store('StopsState', this.state);
        this.loading = false;
      }
    });
  }
}
